import $ from 'jquery';
import _ from 'underscore';
import BaseInput from 'source/lib/component/input/base';
import Settings from 'source/lib/settings_model';
import messages from 'messages';

import template from './template.html';

const PasswordInput = BaseInput.extend({
    name: 'password-input',
    template,
    events: {
        'click .js-password-eye': 'togglePasswordShowing',
    },

    togglePasswordShowing() {
        const $passwordField = this.$('input');
        const $passwordFieldSet = $passwordField.parents('fieldset');
        const $passwordEye = $('.js-password-eye', $passwordFieldSet);
        const passwordEyeBemBlock = $passwordEye.data('bem-block');
        const passwordEyeModifierShow = $passwordEye.data('bem-modifier-show');
        const passwordEyeShowClass = `${passwordEyeBemBlock}__${passwordEyeModifierShow}`;

        const currentType = $passwordField.attr('type');
        const changeType = currentType === 'password' ? 'text' : 'password';

        $passwordEye.toggleClass(passwordEyeShowClass);
        $passwordField.attr('type', changeType);

        // After changing field type, we must manually set focus to the last character
        const hasValue = $passwordField.val() !== '';
        if (hasValue) {
            const element = $passwordField[0];

            if (element.selectionStart || element.selectionStart === 0) {
                const valueLength = element.value.length;

                element.selectionStart = valueLength;
                element.selectionEnd = valueLength;
            }
        }

        $passwordField.focus();
    },

    render() {
        const parent = {
            'parent-uId': this.uId || '',
            'parent-name': this.name || '',
        };
        const context = _.extend({ msgs: messages }, Settings.get(), this.data, parent);
        const rendered = this.template(context);
        const $el = $(rendered);

        this.$el.replaceWith($el);
        this.setElement($el);
        return rendered;
    },
});

export default PasswordInput;
